<template>
  <div class="base64-container">
    <el-card class="box-card">
      <el-row>
        <el-input v-model="text" type="textarea" :rows="4" placeholder="请输入内容" class="input-area"></el-input>
      </el-row>
      <el-row class="button-row">
        <el-button type="primary" @click="base64Encode">base64编码</el-button>
        <el-button type="success" @click="base64Decode">base64解码</el-button>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <div class="result-area">{{str}}</div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {base64} from '../api/base64'
export default {
  name: 'base64',
  data () {
    return {
      text: '',
      str: ''
    }
  },
  methods: {
    base64Encode () {
      const data = '{"text":"' + this.text + '","isEncode":"1"}'
      base64(data).then(response => {
        this.str = response.data
      })
    },

    base64Decode () {
      const data = '{"text":"' + this.text + '","isEncode":"2"}'
      base64(data).then(response => {
        this.str = response.data
      })
    }
  }
}
</script>

<style scoped>
.base64-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.box-card {
  max-width: 100%;
}
.input-area {
  width: 100%;
}
.button-row {
  margin-top: 15px;
}
.result-area {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  min-height: 60px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/view/base64.vue